





































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import  MswAppTitle  from '@/shared/msw-app-title/msw-app-title.vue';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import UUIFComponents from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import {
  SwContentToolbar,
} from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import {
  SwTable, TableColumnConfig, TableEntry,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { v4 as uuidv4 } from 'uuid';
import ExportcsvService from '@/shared/msw-exportcsv.service';
import FileUploadmodal from './file-uploadmodal.vue';
import { PRODUCT_PAGE } from '@/shared/constants';

const cssPrefix = 'lookupTool';
@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTextfield,
    SwContentToolbar,
    SwExpandableTextfield,
    SwTable,
    FileUploadmodal,
  },
})

export default class MswLookupTool extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;
  cssPrefix = cssPrefix;
  searchInputText: string = '';
  isExpandSearchFilter: boolean = true;
  tableData: TableEntry[] = []; // For table data
  isOpenFileUpload: boolean = false;
  PRODUCT_PAGE = PRODUCT_PAGE;
  csvUploadErrorMsg: string = '';

  get tableHeight() {
    return 'calc(100vh - 390px)';
  }
  lookupTableColumnConfig: TableColumnConfig[] = [
    {
      key: 'index',
      type: 'index',
    },
    {
      key: 'serialNumber',
      dataKey: 'serialNumber',
      title: String(this.$t('products.serialNumber')),
    },
    {
      key: 'isAffected',
      dataKey: 'isAffected',
      title: String(this.$t('common.status')),
    },
    {
      key: 'issueDate',
      dataKey: 'issueDate',
      title: String(this.$t('lookupTool.dateAddedToList')),
    },
    {
      key: 'priority',
      dataKey: 'priority',
      title: String(this.$t('manageCase.priority')),
    },
    {
      key: 'isRemedy',
      dataKey: 'isRemedy',
      title: String(this.$t('lookupTool.remediate')),
    },
  ];

  // export table data upto 1000 records
  exportTableData() {
    if (this.tableData && this.tableData.length <= 1000) {
      ExportcsvService.startExport(this.mapDataForExport(this.tableData), 'lookupToolResult.csv');
    }
  }

  mapDataForExport(csvData: any[]) {
    let filterJson: any[] = [];
    const itemHeader: string[] = [];
    this.lookupTableColumnConfig.map((entry: TableColumnConfig) => {
      if (entry.key !== 'index' && typeof entry.title === 'string') {
        itemHeader.push(entry.title.toUpperCase());
      }
    });
    const tempJson: any = [{}, itemHeader];
    csvData.map((dataItem:any) => {
      const obj = {};
      this.lookupTableColumnConfig.forEach((item) => {
        if (item.dataKey) {
          // @ts-ignore
          obj[item.title] = dataItem[item.dataKey];
        }
      });
      tempJson.push(obj);
    });
    filterJson = filterJson.concat(tempJson);
    return filterJson;
  }

  downloadTemplate() {
    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += 'serialNumber\r\nEXAMPLESN123\r\nEXAMPLESN234';
    const data = encodeURI(csvContent);
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.setAttribute('href', data);
    link.setAttribute('download', 'lookupTool.csv');
    link.click();
  }

  handleSearch() {
    const payload = {
      serialnumbers: [
        {
          serialNumber: this.searchInputText,
        },
      ],
    };
    this.searchSerialNumber(payload);
  }
  getUploadCsvData(fileTextLines :any) {
    const finalSlValidate: any[] = fileTextLines.filter((item: any) => item.serialNumber && item.serialNumber !== '');
    this.$store.commit('startLoading');
    const payload = {
      serialnumbers: finalSlValidate,
    };
    this.searchSerialNumber(payload);
  }
  searchSerialNumber(payload: any) {
    this.$store.dispatch('MswLookupToolModule/fetchIssueListLookup', payload)
      .then((response: any) => {
        if ((response.msgCode === 'MSWAPP:SUCCESS') && response.operationStatus === 'OK') {
          this.searchInputText = '';
          const rowData = response.content.serialnumbers;
          this.tableData = rowData?.map((ele : any, index: number) => {
            ele._key = `${uuidv4()}`;
            ele.index = index + 1;
            ele.issueDate = ele.issueDate ? ele.issueDate : '';
            return ele;
          });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response?.msgDesc || this.$t('registerProduct.emptyQuery').toString() });
        }
      })
      .catch((errorResponse: any) => {
        console.table(errorResponse);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }
}
